<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Simulação de cálculo de frete</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table">
                                <div class="box-typical-body">
                                    <div class="container-fluid">
                                        <div class="row loadingDataPosition">
                                            <div class="loadingData" v-if="loading"><div class="loadingDataSpinner"><spinner v-if="loading" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
                                            <div class="container-fluid">
                                                <b-row no-gutters>
                                                    <b-col>
                                                        <div class="fl-flex-label fl-collapsed fl-background">
                                                            <currency-input
                                                           class="form-control"
                                                           v-model="form.peso"
                                                           :auto-decimal-mode="true"
                                                           :currency="{ prefix: ''}"
                                                           :distraction-free="getCurrency"/>
                                                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Peso</label>
                                                        </div>
                                                    </b-col>
                                                    <b-col>
                                                        <div class="fl-flex-label fl-collapsed fl-background">
                                                            <!-- <input type="text" class="form-control" v-model="form.valor"> -->
                                                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Valor</label>
                                                            <currency-input
                                                           class="form-control"
                                                           v-model="form.valor"
                                                           :auto-decimal-mode="true"
                                                           :currency="{ prefix: ''}"
                                                           :distraction-free="getCurrency"/>
                                                        </div>

                                                    </b-col>
                                                    <b-col>
                                                        <multiselect v-model="form.frete_vigencia"
                                                        :options="optionsLivFreteVigencia"
                                                        track-by="value"
                                                        label="label"
                                                        :hide-selected="true"
                                                        placeholder="Tabela de Frete"
                                                        tag-placeholder="Selecionar"
                                                        select-label="Selecionar"
                                                        selected-label="Selecionado"
                                                        deselect-label="Remover"
                                                        ></multiselect>
                                                    </b-col>
                                                </b-row>
                                                <div class="float-right" >
                                                    <b-row no-gutters>
                                                        <b-col>
                                                            <b-btn @click="doSimular()" variant="secondary" :disabled="isDisabled">
                                                                Simular
                                                            </b-btn>
                                                        </b-col>
                                                        <b-col>
                                                            <b-btn @click="doLimpar()" variant="secondary">
                                                                Limpar
                                                            </b-btn>
                                                        </b-col>
                                                    </b-row>
                                                </div>
                                                <b-row class="pt-5" v-if="data != ''">
                                                    <b-col>
                                                        <label>Valor total Frete :</label>
                                                        {{formatNumber(data.vlr_total_frete)}}
                                                    </b-col>
                                                </b-row>
                                                <b-row class="pt-3" v-if="data != ''">
                                                    <h5>Custos</h5>
                                                    <table class="table-striped">
                                                          <thead>
                                                              <tr>
                                                                  <th style="width: 50%">Descrição</th>
                                                                  <th style="width: 25%">Taxa</th>
                                                                  <th style="width: 25%">Valor</th>
                                                              </tr>
                                                           </thead>
                                                           <tbody>
                                                               <tr class="bg-gray-light" style="display: table-row;" v-for="item in data.custos">
                                                                   <td>
                                                                       {{item.descr}}
                                                                   </td>
                                                                   <td>
                                                                       {{formatNumber(item.taxa)}}
                                                                   </td>
                                                                   <td>
                                                                       {{formatNumber(item.vlr)}}
                                                                   </td>
                                                              </tr>
                                                         </tbody>
                                                      </table>
                                                </b-row>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import accounting from 'accounting'


export default {
    data () {
        return {
            date_attributes: [{key: 'today',highlight: true,dates: new Date()}],
            loading: false,
            isDisabled: false,
            loadingData: false,
            isFullscreen: false,
            showModal: false,
            data: '',
            optionsLivFreteVigencia: [],
          form: new Form({
              valor: 0,
              peso: 0,
              frete_vigencia: [],
           }),
       }
    },
    mounted(){
        this.getLivGeral();
    },
    methods: {
         getLivGeral() {
        this.form.get('/api/simulacaocalculofrete/jsonlistgeral').then(response => {
                new ReturnApi(response, this, true, false, false);
                 response.frete_vigencia.forEach((obj) => {
                 this.optionsLivFreteVigencia.push({
                    label:obj.tabela_frete_rota.tabela_frete.cd+' - '+ obj.tabela_frete_rota.tabela_frete.descr+' - '+this.formatDate(obj.dt_vigencia_ini)+ ' - '+(obj.dt_vigencia_fim!=null ? this.formatDate(obj.dt_vigencia_fim) : 'sem data final') + ' - ' + obj.tabfrerotvig_id,
                    value: obj.tabfrerotvig_id

                 })
            });
        })
         .catch(errors => {
             new ReturnApi(errors, this)
            });
        },
        doSimular() {
            this.loading = true;
            this.isDisabled = true;
                this.form.post('/api/simulacaocalculofrete/simular').then(response =>
                {
                    this.data = response;
                    new ReturnApi(response, this)
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
        },
        doLimpar()
        {
            this.form.valor = 0;
            this.form.peso = 0;
            this.form.frete_vigencia = [];
        },
        formatDate (value, fmt = 'DD/MM/YYYY') {
          return (value == null || value == "")
            ? ''
            : moment(value, 'YYYY/MM/DD').format(fmt)
        },
        formatNumber(value) {
            return accounting.formatNumber(value, 2, '.', ',')
        },
        expandFullscreen() {
            this.isFullscreen = !this.isFullscreen;
        },
    },
    computed: {
        vuetableFilterRow: {
            get () {
                return this.$store.getters.vuetable.filterRow;
            },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        },
        getCurrency: {
            get() {
                return this.$store.getters.currency;
            }
        },
    }
}
</script>
